import request from '@/utils/request'

// 查询模板阶段
export function queryDefaultTemplateStage() {
  return request({
    url: '/crmTemplateStage/queryDefaultStage',
    method: 'get'
  })
}
